// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { promotionalESpotStyles } from "@sc/App/Widgets/PromotionalESpot/PromotionalESpot";
import ArrowRight from "@sc/XDL/Icons/ArrowRight";
import { color, createLinkIconStyles, ellipsis, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

promotionalESpotStyles.container = {
    css: css`
        position: relative;
        display: flex;
        align-items: end;
        width: 100%;
        background-color: ${({ backgroundColor }: any) => backgroundColor};

        ${({ heightStyles }: any) =>
            css`
                ${heightStyles}
            `};

        ${xScreen("lte", "lg")} {
            ${({ halfViewPort }: any) => (halfViewPort ? "min-height: 400px;" : "")}
        }
        ${xScreen("lte", "md")} {
            min-height: unset;
        }
    `,
};

promotionalESpotStyles.pictureWrapper = {
    css: css`
        height: 100%;
        display: flex;
        div[class^="LazyImageStyle"] {
            width: 100%;
            justify-content: end;
            picture {
                display: flex;
                height: inherit;
                width: 100%;
                img {
                    height: auto;
                    width: 100%;
                    border-radius: 4px;
                }
            }
        }
    `,
};

promotionalESpotStyles.contetnWrapper = {
    css: css`
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        justify-content: end;
        align-items: baseline;
        gap: 16px;
        padding: 12px;
        border-radius: 4px;
        height: 100%;
        width: 100%;
        ${({ backgroundColor }: any) => backgroundColor && `background-color:${backgroundColor}`}
        ${xScreen("lte", "md")} {
            max-width: 50%;
        }
        ${xScreen("lte", "sm")} {
            max-width: 100%;
        }
    `,
};

promotionalESpotStyles.title = {
    css: css`
        &&& {
            ${TypographyStyle} {
                margin-bottom: 0;
                color: ${color("common.white")};
                ${ellipsis(4)};
            }
        }
    `,
};

promotionalESpotStyles.link = {
    ...createLinkIconStyles(ArrowRight, {
        color: "common.white",
        icon: {
            iconProps: {
                size: 14,
            },
            position: "right",
        },
        typographyProps: {
            size: 16,
            lineHeight: "17px",
        },
    }),
};
